import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateString, ISupportPeriod } from '../../../shared';
import { Box, useTheme } from '@mui/material';

interface Props {
    supportPeriod: ISupportPeriod;
}

export const SupportPeriodInfo: FC<Props> = ({ supportPeriod }) => {
    const { t } = useTranslation();
    const { typography } = useTheme();
    const active = new Date(supportPeriod.startDate) <= new Date() && new Date() <= new Date(supportPeriod.endDate);
    const supportTypes = supportPeriod.supportTypesInfo.map(({ supportType }) => supportType?.name).join(', ');

    return (
        <Box component="span" sx={{ fontSize: typography.body1.fontSize }}>
            {supportTypes}
            {`: ${formatDateString(supportPeriod.startDate)} - ${formatDateString(supportPeriod.endDate)}`}
            {!active && <b> ({t('inactive')})</b>}
        </Box>
    );
};
